import { rutinInfos } from '../../_Common/Const/RutinInfo';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';

const DIRutiner = {
  rtnPostlista: {
    component: getStandardRutin(rutinInfos.rtnPostlista, 'DIPostlista'),
  },
  rtnDiarie: {
    component: getStandardRutin(rutinInfos.rtnDiarie, 'DIArende'),
  },
  rtnDokument: {
    component: getStandardRutin(rutinInfos.rtnDokument, 'DIDokument'),
  },
  rtnVisaPostlista: {
    component: getStandardRutin(rutinInfos.rtnVisaPostlista, 'DIPostlista'), // Samma som Postlista
  },
  rtnVisaDiarie: {
    component: getStandardRutin(rutinInfos.rtnVisaDiarie, 'DIArende'), // Samma som Ärenden
  },
};

export default DIRutiner;
